import { translate, type TranslationKey } from "../locales";

/**
 * The portfolio page is hard-coded Russian and the app has no locale switch (nothing calls
 * `setLocale`), so this panel is always Russian: one language per screen, whatever the browser
 * language is. The English dictionary stays for a future app-level switch.
 */
export const PANEL_LOCALE = "ru-RU";

export function t(key: TranslationKey, params?: Record<string, string | number>): string {
  return translate(PANEL_LOCALE, key, params);
}

export function localeKey(): "en-US" | "ru-RU" {
  return PANEL_LOCALE;
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : new Intl.DateTimeFormat(localeKey(), { dateStyle: "medium", timeStyle: "short" }).format(date);
}
